import React, { useEffect, useState } from 'react';

import Modal from '../components/Shell/Modal';
import { TemplateField } from '../components/Attributes/Attributes_old';
import BetaAttributes from '../components/Attributes';

import Button from '../components/Button';

import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';
import useAsync from '../hooks/useAsync';

import { addCategory } from '../api/categories';

const MODAL_NAME = 'addCategoryModal';

const QuickAddCategory = () => {
	const [form, setForm] = useState({});

	const { open: options, setClose } = useModal(MODAL_NAME);

	const { execute: onAddCategory, status: isAddingCategory } = useAsync(
		addCategory,
		{ immediate: false }
	);

	useEffect(() => {
		if (options) {
			setForm({
				moduleId: options?.moduleId || null,
			});
		} else {
			setForm({});
		}
	}, [options]);

	return (
		<Modal title="Create Category" open={!!options} onClose={() => setClose()}>
			<div className="grid grid-cols-2 gap-y-4 gap-x-4 text-left">
				{options?.moduleId ? null : (
					<BetaAttributes
						field={{ label: 'Module', type: 'module', required: true }}
						form={form}
						onChange={(index, value) =>
							setForm({ ...form, ['moduleId']: value })
						}
						key={'module'}
					/>
				)}

				<TemplateField
					name="Name"
					dataIndex="name"
					onChange={(index, category) =>
						setForm({ ...form, [index]: category })
					}
				/>
			</div>
			<div className="flex justify-end mt-6">
				<Button
					onClick={() => {
						onAddCategory(
							{
								name: form?.name,
								moduleId: form?.moduleId?.value || form?.moduleId,
								organizationId: options?.organizationId,
							},
							(response) => {
								if (typeof options?.onSubmit === 'function') {
									options?.onSubmit({
										label: response.name,
										value: response.id,
									});
									setForm({});
								}
								setClose();
							}
						);
					}}
					disabled={!useRequired(form, ['name', 'moduleId'])}
				>
					{isAddingCategory === 'pending' ? 'Adding Category' : 'Add Category'}
				</Button>
			</div>
		</Modal>
	);
};

export default QuickAddCategory;
